import { TOGGLE_NOTIFICATION_LIST } from 'actions/Types';

export default (state = true, action) => {
  if (action.type === TOGGLE_NOTIFICATION_LIST) return action.payload;

  return state;
};
